import React, { useEffect, useRef } from 'react'
import styles from './Item.module.scss'
import { Draggable } from 'react-beautiful-dnd'
import { useDispatch } from 'react-redux';
import { Checkbox } from 'antd';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { FaPlay, FaVideo } from 'react-icons/fa';

export function getYoutubeId(url) {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
}

export function getVimeoId(url) {
  if (!url) return null;
  const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/)|(video\/))?([0-9]+)\/?.*/;
  const match = url.match(regExp);
  return match ? match[6] : null;
}

function Item({item, selectedSliders, index, onSelectedSlide}) {
  const contentRef = useRef(null);
  const slide = useSelector(state => state.slider.slide)

  const dispatch = useDispatch();
  const renderImage = (item) => {
    var img = new Image();
    img.onload = () => {
      // if(this.props.setLoadImg){
      //   this.props.setLoadImg();
      // }
    };
    img.src = item.src;
    return <div className={styles["ItemImage"]} style={{backgroundImage: `url(${item.src})`}}></div>
  }

  const renderVideoThumbnail = (item) => {
    const youtubeId = getYoutubeId(item.src);
    let bgUrl = '';
    if (youtubeId) {
      bgUrl = `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
    }
    
    return (
      <div 
        className={classNames(styles["ItemImage"], styles["ItemVideo"])} 
        style={bgUrl ? { backgroundImage: `url(${bgUrl})` } : {}}
      >
        {!bgUrl && <FaVideo size={24} color="#555" />}
        <div className={styles["PlayOverlay"]}>
          <FaPlay size={14} color="#fff" />
        </div>
      </div>
    );
  }

  useEffect(() => {
    const el = contentRef.current;

    if (el) {
      el.style.height = el.clientHeight + 'px';
      el.style.paddingTop = 0;
    }
  }, []);

  const renderQuestion = (item) => {

    const text = item.question.question.replace(/<[^>]*>/g, '');
    if(!text){
      let regex = /<img.*?src="(.*?)"/;
      let src = regex.exec( item.question.question )[1];
      return <div className={styles["ItemQuestion"]}>
        <img src={src} />
      </div>
    }

    return <div className={styles["ItemQuestion"]}>
      {text.substring(0, 120)}{text.replace(/<[^>]*>/g, '').length > 120 ? '...' : ''}
    </div>
  }



  return (
    <Draggable draggableId={'slide-'+ item.id} index={index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className={styles["ItemTmp"]}
        >
          <div className={styles["Item"]} ref={contentRef}>
            <div className={styles['count-slider']}>#{index + 1}</div>
            <div className={styles["checkbox-item"]}>
              <Checkbox
                onChange={() => {
                  onSelectedSlide(selectedSliders.includes(item.id) ? selectedSliders.filter(id => item.id != id) : [...selectedSliders, item.id])
                }} 
                checked={selectedSliders.includes(item.id)} 
              />
            </div>
            
            <div {...provided.dragHandleProps}  
              className={classNames(styles["item_content"], {[styles.active]: slide && slide.id == item.id})} 
              onClick={() => {
                dispatch({type: 'SET_SLIDERS_KEY', key: 'slide', data: item})
              }}
            >
              {item.type == "image" && renderImage(item)}
              {item.type == "question" && renderQuestion(item)}
              {item.type == "video" && renderVideoThumbnail(item)}
            </div>
          </div>
        </div>
      )}
    </Draggable>
  )
}

export default Item